import { DashboardAPI } from '@business/api/dashboard';
import { DashboardId, DashboardEmailResponse, DashboardEmailId } from '@business/entities/dashboard';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { showDeleteConfirmation } from '@modules/common';
import { switchMap } from 'rxjs/operators';

export class DashboardEmailBloc extends BaseBloc {
  private readonly dashboardRepo = new Repository<DashboardEmailResponse>({
    getItemId: dashboard => dashboard.id,
  });

  readonly dashboardEmails$ = this.dashboardRepo.items$;
  selectEmail = this.dashboardRepo.selectItem;

  onReset() {
    this.dashboardRepo.reset();
  }

  fetchDashboardEmails = (id: DashboardId) => {
    return DashboardAPI.fetchDashboardEmails(id).pipe(
      this.dashboardRepo.ops.reset(),
      handleMessage({ error: requestMessage('fetch_dashboard_emails_error') }),
    );
  };

  fetchDashboardEmail = (id: DashboardEmailId) => {
    return DashboardAPI.fetchDashboardEmail(id).pipe(
      this.dashboardRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_dashboard_emails_error') }),
    );
  };

  createDashboardEmail = (id: DashboardId, data: Partial<DashboardEmailResponse>) => {
    return DashboardAPI.createDashboardEmail(id, data).pipe(
      this.dashboardRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_dashboard_email'),
      }),
    );
  };

  updateDashboardEmail = (id: DashboardEmailId, data: Partial<DashboardEmailResponse>) => {
    return DashboardAPI.updateDashboardEmail(id, data).pipe(
      this.dashboardRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_dashboard_email'),
      }),
    );
  };

  deleteDashboardEmail = (id: DashboardEmailId) => {
    return showDeleteConfirmation('Delete Emails', 'Do you really want to remove this dashboard email?').pipe(
      switchMap(() => DashboardAPI.deleteDashboardEmail(id)),
      this.dashboardRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_dashboard_email'),
      }),
    );
  };
}
